<template>
<v-dialog v-model="dialog" max-width="800px" persistent>
  <el-button type="primary" dark slot="activator">Add Patients</el-button>
  <v-flex xs12>
    <v-card class="the--card">
      <v-layout row wrap>
        <v-flex xs12>
          <v-btn icon @click.native="closePopup()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <ExistingRegistration></ExistingRegistration>
    </v-card>
  </v-flex xs12>
</v-dialog>
</template>
<script>
import NewRegistration from './NewRegistration';
import ExistingRegistration from './ExistingRegistration';
export default {
  components: {
    NewRegistration,
    ExistingRegistration
  },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    closePopup(){
    this.dialog = false
    }
  }
};
</script>
<style scoped>
.the--card .layout:first-child {
  padding-right: 1rem;
  text-align: right;
}
.the--card .layout:last-child {
  padding: 1rem;
}

#registration {
  margin-right: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/AddPatient.vue